import { buildUtilityRoutePathMap, buildUtilitySeoRoutes } from '@saas-pages/shared/public/registry'
import { toSeoProps, withDefaultJsonLd, type SeoRouteConfig, type UmbrellaSeoRoutes } from '@saas-pages/shared/public/seo'
import branding from '../../branding.config'
import { mediatikUtilityRegistry, type RouteKey as ToolRouteKey } from '@/shared/utility-registry'

export type { ToolRouteKey }
export type AppRouteKey = 'index' | 'blog' | ToolRouteKey
const toolSeoRoutes = buildUtilitySeoRoutes(branding.domain, mediatikUtilityRegistry)

const rawSeoRoutes: UmbrellaSeoRoutes<AppRouteKey> = {
  domain: branding.domain,
  routes: {
    index: {
      path: '/',
      title: 'Запись и обрезка аудио, круглое видео онлайн — mediatik.ru',
      description: 'Бесплатные локальные инструменты для записи голоса, обрезки аудио и записи круглого видео. Без регистрации и загрузки файлов на сервер.',
      changefreq: 'weekly', priority: 1,
    },
    blog: {
      path: '/blog',
      title: 'Блог о записи аудио и видео в браузере — mediatik.ru',
      description: 'Практические статьи mediatik.ru о форматах аудиозаписи, работе MediaRecorder и локальной записи голоса и видео в браузере.',
      changefreq: 'weekly', priority: 0.8,
    },
    ...toolSeoRoutes.routes,
  } as Record<AppRouteKey, SeoRouteConfig>,
}

export const seoRoutes = withDefaultJsonLd(rawSeoRoutes, 'Catalog page has no page-specific structured data.')
export const routePath: Record<ToolRouteKey, string> = buildUtilityRoutePathMap(mediatikUtilityRegistry)
export function seoFor(key: AppRouteKey) { return toSeoProps(branding.domain, seoRoutes.routes[key]!) }
